import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { FormattedMessage, useIntl } from 'react-intl';

import CustomPagination from '../../../components/CustomPagination/CustomPagination';
import CommonTable from '../../../components/CommonTable/CommonTable';
import Loader from '../../../components/Loader/Loader';
import CustomConfirmModal from '../../../components/Common/CustomConfirmModal/CustomConfirmModal';
import messages from '../../../locale/jsonMessages';
import { contactInquiriesQuery } from '../../../lib/graphql';
import debounce from '../../../helpers/debounce';

function ContactInquiriesManagement() {
    const intl = useIntl();
    const { formatMessage } = intl;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchList, setSearchList] = useState('');
    const [messageModal, setMessageModal] = useState(null);

    const { data, loading, refetch } = useQuery(contactInquiriesQuery, {
        variables: {
            currentPage: 1,
            searchList: '',
        },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    const contactInquiries = data?.getAllContactInquiriesAdmin;

    const handleSearchChange = debounce((e) => {
        const value = e.target.value;
        setCurrentPage(1);
        setSearchList(value);
        refetch({
            currentPage: 1,
            searchList: value,
        });
    }, 200);

    const paginationData = (page) => {
        setCurrentPage(page);
        refetch({
            currentPage: page,
            searchList,
        });
    };

    const openMessageModal = (message) => {
        setMessageModal(message);
    };

    const closeMessageModal = () => {
        setMessageModal(null);
    };

    const thead = () => [
        { data: formatMessage(messages.name) },
        { data: formatMessage(messages.phoneNumber) },
        { data: formatMessage(messages.emailIdLabel) },
        { data: formatMessage(messages.message) },
    ];

    const tbody = () => contactInquiries?.contactInquiriesData?.map((value, key) => ({
        id: key,
        data: [
            { data: value?.name },
            { data: value?.phoneNumber },
            { data: value?.email },
            {
                data: value?.message ? (
                    <a
                        href="javascript:void(0)"
                        onClick={() => openMessageModal(value.message)}
                    >
                        <FormattedMessage {...messages.viewMessageLabel} />
                    </a>
                ) : '-',
            },
        ],
    }));

    return (
        <div>
            {messageModal && (
                <CustomConfirmModal
                    showModel={!!messageModal}
                    closeModal={closeMessageModal}
                    title={formatMessage(messages.message)}
                >
                    {messageModal}
                </CustomConfirmModal>
            )}
            {loading && <Loader type={"text"} />}
            {!loading && <div>
                <CommonTable
                    title={formatMessage(messages.manageContactInquiries)}
                    thead={thead}
                    tbody={tbody}
                    isSearch
                    onSearch={handleSearchChange}
                    isExport
                    exportLink={contactInquiries?.contactInquiriesData?.length > 0 ? `/export-admin-data?type=contact-inquiries&search=${searchList}` : null}
                />
                {
                    contactInquiries?.contactInquiriesData?.length > 0 &&
                    <CustomPagination
                        total={contactInquiries.count}
                        currentPage={currentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={paginationData}
                        paginationLabel={formatMessage(messages.manageContactInquiries)}
                        isScroll
                    />
                }
            </div>}
        </div>
    );
}

export default ContactInquiriesManagement;
